<tec-base>
    <tec-topnav
        [img]="'assets/images/tecalis' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
        title="Enlaces de prueba"
    >
        <!-- <tec-button-icon icon="icon-close" [routerLink]="'/models'"></tec-button-icon> -->
    </tec-topnav>
    <tec-dashboard-layout>
        <ng-container dashboard>
            @if (securityCode) {
                <tec-tile>
                    <h4>Pruebas predefinidas</h4>
                    @if (securityCode === 'tecalis') {
                        <div class="grid grid-i3">
                            <tec-card-access
                                [type]="'default'"
                                [size]="'default'"
                                [disabled]="false"
                                [title]="'Lectura de documento y prueba de vida'"
                                [description]="'PWCS A - Home, lectura de documento de identidad y prueba de vida'"
                                [buttonLabel]="'Empezar'"
                                [tags]="[{ label: 'ES', status: 'error' }, 'HOME', 'OCR', 'POL']"
                                (click)="loginProfile(profiles.es.pwcsa)"
                            />
                            <tec-card-access
                                [type]="'default'"
                                [size]="'default'"
                                [disabled]="false"
                                [title]="'Solo lectura de documento'"
                                [description]="'PWCS A - Home y lectura de documento de identidad'"
                                [buttonLabel]="'Empezar'"
                                [tags]="[{ label: 'ES', status: 'error' }, 'HOME', 'OCR']"
                                (click)="loginProfile(profiles.es.onlyOcr)"
                            />
                            <tec-card-access
                                [type]="'default'"
                                [size]="'default'"
                                [disabled]="false"
                                [title]="'Solo prueba de vida'"
                                [description]="'PWCS A - Home y prueba de vida'"
                                [buttonLabel]="'Empezar'"
                                [tags]="[{ label: 'ES', status: 'error' }, 'HOME', 'POL']"
                                (click)="loginProfile(profiles.es.onlyPol)"
                            />
                            <tec-card-access
                                [type]="'default'"
                                [size]="'default'"
                                [disabled]="false"
                                [title]="'Lectura de documento, prueba de vida y subida de documento'"
                                [description]="
                                    'PWCS B - Home, lectura de documento de identidad, prueba de vida y documento'
                                "
                                [buttonLabel]="'Empezar'"
                                [tags]="[{ label: 'ES', status: 'error' }, 'HOME', 'OCR', 'POL', 'DOCS']"
                                (click)="loginProfile(profiles.es.pwcsb)"
                            />
                            <tec-card-access
                                [type]="'default'"
                                [size]="'default'"
                                [disabled]="false"
                                [title]="'Solo subida de documento'"
                                [description]="'PWCS B - Subida de documento'"
                                [buttonLabel]="'Empezar'"
                                [tags]="[{ label: 'ES', status: 'error' }, 'HOME', 'DOCS']"
                                (click)="loginProfile(profiles.es.onlyDoc)"
                            />
                            <tec-card-access
                                [type]="'default'"
                                [size]="'default'"
                                [disabled]="false"
                                [title]="'Lectura de documento, prueba de vida y selección de documentos'"
                                [description]="'Selector de opciones'"
                                [buttonLabel]="'Empezar'"
                                [tags]="[{ label: 'ES', status: 'error' }, 'HOME', 'OCR', 'POL', 'CHOOSE']"
                                (click)="loginProfile(profiles.es.choose)"
                            />
                            <tec-card-access
                                [type]="'default'"
                                [size]="'default'"
                                [disabled]="false"
                                [title]="'Pruebas 2'"
                                [description]="'PWCS B - Home, lectura de documento de identidad y subida de documento'"
                                [buttonLabel]="'Empezar'"
                                [tags]="[{ label: 'ES', status: 'error' }, 'HOME', 'OCR', 'POL', 'DOCS']"
                                (click)="loginProfile(profiles.es.pwcsTest2)"
                            />
                            <tec-card-access
                                [type]="'default'"
                                [size]="'default'"
                                [disabled]="false"
                                [title]="'Documento genérico'"
                                [description]="'Lectura de documento genérico'"
                                [buttonLabel]="'Empezar'"
                                [tags]="[{ label: 'ES', status: 'error' }, 'HOME', 'DOCS']"
                                (click)="loginProfile(profiles.es.genericDocument)"
                            />
                            <tec-card-access
                                [type]="'default'"
                                [size]="'default'"
                                [disabled]="false"
                                [title]="'SURA - Lectura de documento y prueba de vida'"
                                [description]="'Documentos solo colombianos'"
                                [buttonLabel]="'Empezar'"
                                [tags]="[{ label: 'ES', status: 'error' }, 'HOME', 'DOC']"
                                (click)="loginProfile(profiles.es.sura)"
                            />
                            <tec-card-access
                                [type]="'default'"
                                [size]="'default'"
                                [disabled]="false"
                                [title]="'Video'"
                                [description]="'Video'"
                                [buttonLabel]="'Empezar'"
                                [tags]="['HOME', 'OCR']"
                                (click)="loginProfile(profiles.es.video)"
                            />
                        </div>
                        <tec-tile title="Conexiones">
                            <div class="grid grid-d4">
                                <tec-card-access
                                    [type]="'default'"
                                    [size]="'default'"
                                    [disabled]="false"
                                    [title]="'Lectura de documento y bank scoring'"
                                    [description]="'Home, lectura de documento de identidad y conexión bank scoring'"
                                    [buttonLabel]="'Empezar'"
                                    [tags]="[{ label: 'ES', status: 'error' }, 'HOME', 'OCR', 'CONEX']"
                                    (click)="loginProfile(profiles.es.ocrAndBankscoring)"
                                />
                                <tec-card-access
                                    [type]="'default'"
                                    [size]="'default'"
                                    [disabled]="false"
                                    [title]="'Lectura de documento y IRPF'"
                                    [description]="'Home, lectura de documento de identidad y conexión IRPF'"
                                    [buttonLabel]="'Empezar'"
                                    [tags]="[{ label: 'ES', status: 'error' }, 'HOME', 'OCR', 'CONEX']"
                                    (click)="loginProfile(profiles.es.ocrAndIrpf)"
                                />
                                <tec-card-access
                                    [type]="'default'"
                                    [size]="'default'"
                                    [disabled]="false"
                                    [title]="'Lectura de documento y Escrituras'"
                                    [description]="'Home, lectura de documento de identidad y conexión escrituras'"
                                    [buttonLabel]="'Empezar'"
                                    [tags]="[{ label: 'ES', status: 'error' }, 'HOME', 'OCR', 'CONEX']"
                                    (click)="loginProfile(profiles.es.ocrAndScripture)"
                                />
                                <tec-card-access
                                    [type]="'default'"
                                    [size]="'default'"
                                    [disabled]="false"
                                    [title]="'Lectura de documento y vida laboral'"
                                    [description]="'Home, lectura de documento de identidad y conexión vida laboral'"
                                    [buttonLabel]="'Empezar'"
                                    [tags]="[{ label: 'ES', status: 'error' }, 'HOME', 'OCR', 'CONEX']"
                                    (click)="loginProfile(profiles.es.ocrAndWorklife)"
                                />
                            </div>
                        </tec-tile>
                        <tec-tile title="Inglés">
                            <div class="grid grid-i2">
                                <tec-card-access
                                    [type]="'default'"
                                    [size]="'default'"
                                    [disabled]="false"
                                    [title]="'Document reading and proof of life'"
                                    [description]="'PWCS A - Home, document reading and proof of life'"
                                    [buttonLabel]="'Start'"
                                    [tags]="[{ label: 'EN', status: 'success' }, 'HOME', 'OCR', 'POL']"
                                    (click)="loginProfile(profiles.en.pwcsa)"
                                />
                                <tec-card-access
                                    [type]="'default'"
                                    [size]="'default'"
                                    [disabled]="false"
                                    [title]="'Document reading, proof of life and document upload'"
                                    [description]="
                                        'PWCS B - Home, identity document reading, proof of life and document'
                                    "
                                    [buttonLabel]="'Start'"
                                    [tags]="[{ label: 'EN', status: 'success' }, 'HOME', 'OCR', 'POL', 'DOCS']"
                                    (click)="loginProfile(profiles.en.pwcsb)"
                                />
                            </div>
                        </tec-tile>
                    }
                    @if (securityCode === 'tecalis_tests') {
                        <div class="grid grid-i3">
                            <tec-card-access
                                [title]="'Anverso y reverso + prueba de vida + RPA IRPF'"
                                [description]="'B2C / Anverso y reverso + prueba de vida + RPA IRPF'"
                                [buttonLabel]="'Empezar'"
                                [tags]="[{ label: 'ES', status: 'error' }, 'HOME', 'OCR', 'POL', 'DOCS']"
                                (click)="loginProfile(profiles.tecalisTests.a)"
                            />
                            <tec-card-access
                                [title]="'Anverso y reverso + prueba de vida + RPA SS'"
                                [description]="'B2C / Anverso y reverso + prueba de vida + RPA SS'"
                                [buttonLabel]="'Empezar'"
                                [tags]="[{ label: 'ES', status: 'error' }, 'HOME', 'OCR', 'POL', 'DOCS']"
                                (click)="loginProfile(profiles.tecalisTests.b)"
                            />
                            <tec-card-access
                                [title]="'Anverso y reverso + prueba de vida + recogida de documentos'"
                                [description]="'B2C / Anverso y reverso + prueba de vida + recogida de documentos'"
                                [buttonLabel]="'Empezar'"
                                [tags]="[{ label: 'ES', status: 'error' }, 'HOME', 'OCR', 'POL', 'DOCS']"
                                (click)="loginProfile(profiles.tecalisTests.c)"
                            />
                            <tec-card-access
                                [title]="'Anverso y reverso + prueba de vida + AML + PEP + Video'"
                                [description]="'B2C / Anverso y reverso + prueba de vida + AML + PEP + Video'"
                                [buttonLabel]="'Empezar'"
                                [tags]="[{ label: 'ES', status: 'error' }, 'HOME', 'OCR', 'POL']"
                                (click)="loginProfile(profiles.tecalisTests.d)"
                            />
                            <tec-card-access
                                [title]="'Anverso y reverso + prueba de vida'"
                                [description]="'B2C / Anverso y reverso + prueba de vida'"
                                [buttonLabel]="'Empezar'"
                                [tags]="[{ label: 'ES', status: 'error' }, 'HOME', 'OCR', 'POL']"
                                (click)="loginProfile(profiles.tecalisTests.e)"
                            />
                        </div>
                    }
                    @if (securityCode === 'rentik') {
                        <div class="grid grid-e3">
                            <tec-card-access
                                [type]="'default'"
                                [size]="'default'"
                                [disabled]="false"
                                [title]="'Rentik 1'"
                                [description]="'Perfil con lectura de documento de identidad y prueba de vida'"
                                [buttonLabel]="'Empezar'"
                                [tags]="['HOME', 'OCR', 'POL']"
                                (click)="loginProfile(profiles.Rentik1)"
                            />
                            <tec-card-access
                                [type]="'default'"
                                [size]="'default'"
                                [disabled]="false"
                                [title]="'Rentik 2'"
                                [description]="
                                    'Perfil con lectura de documento de identidad (comprobación de carta verde) y prueba de vida'
                                "
                                [buttonLabel]="'Empezar'"
                                [tags]="['HOME', 'OCR', 'POL']"
                                (click)="loginProfile(profiles.Rentik2)"
                            />
                        </div>
                    }
                    @if (securityCode === 'waiis') {
                        <div class="grid grid-e3">
                            <tec-card-access
                                [type]="'default'"
                                [size]="'default'"
                                [disabled]="false"
                                [title]="'WAIIS'"
                                [description]="
                                    'Perfil con lectura de documento de identidad, prueba de vida y subida de documento'
                                "
                                [buttonLabel]="'Empezar'"
                                [tags]="['HOME', 'OCR', 'POL', 'DOCS']"
                                (click)="loginProfile(profiles.WAIIS)"
                            />
                        </div>
                    }
                </tec-tile>
            }

        </ng-container>
    </tec-dashboard-layout>
    <tec-watermark type="default" />
</tec-base>

@if (loading) {
    <tec-spinner [show]="loading !== ''" [text]="loading" [opaque]="true" [watermark]="true" />
}
